import { useMemo } from 'react';
import { SEARCH_QUERY as PUBLIC_SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc.dfc.new';
import { SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc.dfc.new';
import { usePersonalizationQuery } from '../../hooks/usePersonalizationQuery';
import { DATA_TYPE_MAP } from '../../search-results/utils/searchMappers';
export function useGetPartnerCount(selectedService, selectedIndustries = [], selectedCountry = null, requireOfficeInCountry = false, selectedLanguages = []) {
  var _result$total, _ref;
  const countFilter = useMemo(() => {
    const filtersByField = {
      PRODUCT_TYPE: [{
        values: ['SOLUTIONS_PARTNER_PROFILE'],
        negation: false,
        clause: 'OR',
        __typename: DATA_TYPE_MAP.STRING
      }]
    };
    if (selectedService) {
      filtersByField.PROFILE_CATALOG_SERVICES = [{
        values: [Number(selectedService)],
        negation: false,
        clause: 'OR',
        __typename: DATA_TYPE_MAP.LONG
      }];
    }
    if (selectedIndustries.length > 0) {
      filtersByField.PROFILE_INDUSTRIES = [{
        values: selectedIndustries,
        negation: false,
        clause: 'OR',
        __typename: DATA_TYPE_MAP.STRING
      }];
    }
    if (selectedCountry) {
      filtersByField.PROFILE_LOCATION_COUNTRY = [{
        values: [selectedCountry],
        negation: false,
        clause: 'OR',
        __typename: DATA_TYPE_MAP.STRING
      }];
    }
    if (requireOfficeInCountry && selectedCountry) {
      filtersByField.PROFILE_OFFICE_LOCATION = [{
        values: [selectedCountry],
        negation: false,
        clause: 'OR',
        __typename: DATA_TYPE_MAP.STRING
      }];
    }
    if (selectedLanguages.length > 0) {
      filtersByField.PROFILE_LANGUAGES = [{
        values: selectedLanguages,
        negation: false,
        clause: 'OR',
        __typename: DATA_TYPE_MAP.STRING
      }];
    }
    return {
      filterGroups: [{
        filtersByField,
        clause: 'AND',
        negation: false
      }],
      clause: 'AND',
      negation: false
    };
  }, [requireOfficeInCountry, selectedCountry, selectedLanguages, selectedIndustries, selectedService]);
  const {
    data: countData,
    previousData
  } = usePersonalizationQuery({
    app: SEARCH_QUERY,
    public: PUBLIC_SEARCH_QUERY,
    options: {
      variables: {
        filter: countFilter,
        length: 0,
        offset: 0
      }
    }
  });
  return (_result$total = (_ref = countData !== null && countData !== void 0 ? countData : previousData) === null || _ref === void 0 || (_ref = _ref.result) === null || _ref === void 0 ? void 0 : _ref.total) !== null && _result$total !== void 0 ? _result$total : 0;
}